export default ({ request }) => ({
  factoryMrpSubgroupTreeApi(data = {}) {
    return request({
      url: "/factory/mrp/subgroup/tree",
      method: "post",
      data,
    });
  },
  factoryMrpSubgroupSaveApi(data = {}) {
    return request({
      url: "/factory/mrp/subgroup/save",
      method: "post",
      data,
    });
  },
  factoryMrpSubgroupDetailApi(data = {}) {
    return request({
      url: "/factory/mrp/subgroup/detail",
      method: "post",
      data,
    });
  },
  factoryMrpSubgroupDelApi(data = {}) {
    return request({
      url: "/factory/mrp/subgroup/del",
      method: "post",
      data,
    });
  },
  factoryMrpSubgroupMemberListApi(data = {}) {
    return request({
      url: '/factory/mrp/subgroup/member/list',
      method: 'post',
      data
    })
  },
  factoryMrpSubgroupMemberSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/subgroup/member/save',
      method: 'post',
      data
    })
  },
  factoryMrpSubgroupMemberDelApi(data = {}) {
    return request({
      url: '/factory/mrp/subgroup/member/del',
      method: 'post',
      data
    })
  },
  factoryMemberChooseUserListApi(data = {}) {
    return request({
      url: '/factory/mrp/subgroup/member/choose/user/list',
      method: 'post',
      data
    })
  },
  factoryMemberSyncUserApi(data = {}) {
    return request({
      url: '/factory/mrp/subgroup/sync/user',
      method: 'post',
      data
    })
  },
});
